module.exports = function getResource(label) {
    const resources = { onlyAFewLeft: 'plus que quelques articles en stock' };
    return resources[label];
};
